/**
 * Puerto de interacción de UI (confirmaciones y toasts). MVP: reutiliza `SplitsDialogService`
 * sin modificarlo. Integración: `ngx-toastr` + `MatDialog` de Medellín Joven.
 */
export type TipoAviso = 'exito' | 'error' | 'advertencia' | 'info';

export interface OpcionesConfirmacion {
  titulo: string;
  mensaje: string;
  detalle?: string;
  tipo?: 'peligro' | 'advertencia' | 'info';
  textoConfirmar?: string;
  textoCancelar?: string;
}

export abstract class AsistenciaUiPort {
  abstract confirmar(op: OpcionesConfirmacion): Promise<boolean>;
  abstract avisar(mensaje: string, tipo?: TipoAviso, duracionMs?: number): void;
  abstract alertar(titulo: string, mensaje: string, tipo?: 'error' | 'exito' | 'info' | 'advertencia', detalle?: string): void;
}
